import { useEffect, useRef } from "react";

export const useFontSize = (text: string, maxFontSize: number = 2.5) => {
    const containerRef = useRef<HTMLDivElement>(null);
    const textRef = useRef<HTMLParagraphElement>(null);
  
    useEffect(() => {
      resizeText();
    }, [text]);
  
    function resizeText() {
      const container = containerRef.current;
      const text = textRef.current;
  
      if (!container || !text) {
        return;
      }
  
      // set default font size to '16px' and then resize based on the container's space
      text.style.fontSize = `${maxFontSize}rem`;
  
      while (container.scrollHeight > container.clientHeight) {
        text.style.fontSize = `${parseFloat(getComputedStyle(text).fontSize) - 1}px`;
      }
    }
  
    return { containerRef, textRef };
};